import React, { Fragment, Component } from 'react'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import Dialog from '../../components/IdentifiedDialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import withMobileDialog from '@material-ui/core/withMobileDialog'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import { connect } from 'react-redux'
import { referencesActions, messageActions } from '../../actions'
import { withStyles } from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress'
import Typography from '@material-ui/core/Typography'
import { readOnly } from '../../utils/permissions'
import TextField from '@material-ui/core/TextField'

const styles = theme => ({
  box: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    margin: 'auto',
    width: '80%',
    maxWidth: '400px',
    background: 'blue'
  }),
  errorMessage: {
    position: 'absolute',
    bottom: '-22px',
    left: 0
  },
  wrapperLoader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '280px',
    width: '100%',
    height: '100%',
    minHeight: '200px'
  },
  formGroup: {
    padding: '12px 0'
  },
  root: {
    display: 'flex',
    minHeight: '100%',
    padding: '16px 0',
    boxSizing: 'border-box',
    flexDirection: 'column',
    background: '#fafafa'
  },
  formControl: {
    margin: '14px 0'
  }
})

class EditModal extends Component {
  state = {
    referenceEditor: ''
  }

  handleSave = reference => {
    const { onClose, addReference, editReference, changeMessage } = this.props
    if (reference._id) {
      editReference(reference).then(res => {
        changeMessage({ message: 'Alteração realizada com sucesso.' })
        onClose()
      })
    } else {
      addReference(reference).then(res => {
        changeMessage({ message: 'Cadastro realizado com sucesso.' })
        onClose()
      })
    }
  }

  handleSubmit = (e, reference) => {
    e.preventDefault()
    const { setReferenceFormTouched } = this.props
    const { referenceEditor } = this.state

    reference.descricao = referenceEditor

    if (reference.descricao) this.props.referenceFormErrors.valid = true

    if (this.props.referenceFormErrors.valid) {
      this.handleSave(reference)
    } else {
      setReferenceFormTouched()
    }
    return false
  }

  clearErrors = () => {
    this.setState({ formErrors: {} })
  }

  componentWillReceiveProps(newProps) {
    if (this.props.open) {
      if (newProps.reference.descricao) {
        this.setState({ referenceEditor: newProps.reference.descricao })
      }
    } else {
      if (!newProps.loadingReference) this.setState({ referenceEditor: '' })
    }
  }

  render() {
    const {
      fullScreen,
      onClose,
      open = false,
      classes,
      reference,
      loadingReference,
      referenceFormErrors,
      formTouched,
      token
    } = this.props

    const { referenceEditor } = this.state
    const { handleSubmit } = this
    const isReadOnly = readOnly('referencias', token)

    return (
      <div>
        <Dialog
          modalId={reference._id ? 'referencias-editar' : 'referencias-nova'}
          modalParams={{ registro: reference._id }}
          fullScreen={fullScreen}
          fullWidth
          open={open}
          onClose={onClose}
          className={classes.dialog}
        >
          {loadingReference ? (
            <div className={classes.wrapperLoader}>
              <CircularProgress />
            </div>
          ) : (
            <Fragment>
              <DialogTitle id={(reference._id ? 'referencias-editar' : 'referencias-nova') + '-title'}>
                {isReadOnly ? (
                  'Referência'
                ) : (
                  <Fragment>
                    {reference._id ? 'Editar referência' : 'Cadastrar referência'}
                  </Fragment>
                )}
              </DialogTitle>

              <DialogContent>
                <form
                  id={'reference-form'}
                  noValidate
                  onSubmit={e => {
                    handleSubmit(e, reference)
                  }}
                >
                  <FormControl
                    error={
                      !((referenceFormErrors.fields || {})['descricao'] || {}).valid && formTouched
                    }
                    className={classes.formControl}
                    fullWidth
                  >
                    <TextField
                      id="field-descricao"
                      label="Referência"
                      disabled={isReadOnly}
                      fullWidth
                      multiline
                      rows={4}
                      variant="outlined"
                      value={referenceEditor}
                      onChange={event => {
                        this.setState({ referenceEditor: event.target.value })
                      }}
                    />
                    {!((referenceFormErrors.fields || {})['descricao'] || {}).valid &&
                    formTouched ? (
                      <Typography className={classes.errorMessage} noWrap color={'error'}>
                        {((referenceFormErrors.fields || {})['descricao'] || {}).errorMessage}
                      </Typography>
                    ) : null}
                  </FormControl>
                </form>
              </DialogContent>
              <DialogActions>
                <Button onClick={onClose} color="default">
                  {isReadOnly ? 'Voltar' : 'Cancelar'}
                </Button>
                {!isReadOnly && (
                  <Button type={'submit'} form={'reference-form'} color="primary" variant="raised">
                    Salvar
                  </Button>
                )}
              </DialogActions>
            </Fragment>
          )}
        </Dialog>
      </div>
    )
  }
}

EditModal.propTypes = {
  fullScreen: PropTypes.bool.isRequired
}

const mapStateToProps = state => {
  return {
    reference: state.references.reference,
    loadingReference: state.references.loadingReference,
    referenceFormErrors: state.references.referenceFormErrors,
    formTouched: state.references.referenceFormTouched,
    token: state.auth.token
  }
}

const mapDispatchToProps = dispatch => {
  return {
    openModal: () => {
      dispatch(referencesActions.openModal())
    },
    closeModal: () => {
      dispatch(referencesActions.closeModal())
    },
    handleChangeReference: reference => {
      dispatch(referencesActions.handleChangeReference(reference))
    },
    addReference: reference => {
      return dispatch(referencesActions.addReference(reference))
    },
    editReference: reference => {
      return dispatch(referencesActions.editReference(reference))
    },
    setReferenceFormTouched: reference => {
      dispatch(referencesActions.setReferenceFormTouched())
    },
    changeMessage: ({ message }) => {
      dispatch(messageActions.changeMessage({ message }))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withMobileDialog()(withStyles(styles)(EditModal)))



// WEBPACK FOOTER //
// ./src/containers/References/EditModal.js